"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _middleware = require("./middleware");
var bundleReducer = function bundleReducer(reducer) {
  return function (state, action) {
    // First check if this action has any "middleware" functionality we want to run
    if (Array.isArray(_middleware.middleware[action.type])) {
      _middleware.middleware[action.type].forEach(function (func) {
        return func(action);
      });
    }
    var newState = {}; // Then return the new object state based on the results
    // of our individual reducers

    Object.keys(reducer).forEach(function (key) {
      newState[key] = reducer[key](state[key], action);
    });
    return newState;
  };
};
var _default = bundleReducer;
exports["default"] = _default;